// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { NumberUtils } from '@shared/util/number-utils';
import { StringUtils } from '@shared/util/string-utils';

@Injectable({ providedIn: 'root' })
export class CookieStorage {
  public get lastSelectLanguage(): string {
    return this.read('lastSelectLanguage');
  }

  public set lastSelectLanguage(lastSelectLanguage: string) {
    this.write('lastSelectLanguage', lastSelectLanguage);
  }

  public set lastSelectedArticleCollectionId(lastSelectedArticleCollectionId: number) {
    this.writeNumber('lastSelectedArticleCollectionId', lastSelectedArticleCollectionId);
  }

  public get lastSelectedArticleCollectionId(): number {
    return this.readNumber('lastSelectedArticleCollectionId');
  }

  public get withPESymbolInLabelEditor(): boolean {
    const value: string = this.read('withPESymbolInLabelEditor');
    return value === null ? true : StringUtils.parseBoolean(value);
  }

  public set withPESymbolInLabelEditor(value: boolean) {
    this.write('withPESymbolInLabelEditor', value.toString(), 1);
  }

  public get withNSymbolInLabelEditor(): boolean {
    const value: string = this.read('withNSymbolInLabelEditor');
    return value === null ? true : StringUtils.parseBoolean(value);
  }

  public set withNSymbolInLabelEditor(value: boolean) {
    this.write('withNSymbolInLabelEditor', value.toString(), 1);
  }

  public get lastSelectedLabelEditorTabType(): string {
    return this.read('lastSelectedLabelEditorTabType');
  }

  public set lastSelectedLabelEditorTabType(lastSelectedLabelEditorTabType: string) {
    this.write('lastSelectedLabelEditorTabType', lastSelectedLabelEditorTabType, 1);
  }

  public get lastSelectedNonDirectPrintingLabelEditorTabType(): string {
    return this.read('lastSelectedNonDirectPrintingLabelEditorTabType');
  }

  public set lastSelectedNonDirectPrintingLabelEditorTabType(lastSelectedNonDirectPrintingLabelEditorTabType: string) {
    this.write('lastSelectedNonDirectPrintingLabelEditorTabType', lastSelectedNonDirectPrintingLabelEditorTabType, 1);
  }

  public get lastSelectedSeparateLabelEditorTabPositionNumber(): string {
    return this.read('lastSelectedSeparateLabelEditorTabPositionNumber');
  }

  public set lastSelectedSeparateLabelEditorTabPositionNumber(lastSelectedSeparateLabelEditorTabPositionNumber: string) {
    this.write('lastSelectedSeparateLabelEditorTabPositionNumber', lastSelectedSeparateLabelEditorTabPositionNumber, 1);
  }

  public get lastSelectedSeparateLabelEditorTabArticleNumber(): string {
    return this.read('lastSelectedSeparateLabelEditorTabArticleNumber');
  }

  public set lastSelectedSeparateLabelEditorTabArticleNumber(lastSelectedSeparateLabelEditorTabArticleNumber: string) {
    this.write('lastSelectedSeparateLabelEditorTabArticleNumber', lastSelectedSeparateLabelEditorTabArticleNumber, 1);
  }

  public get userConfirmedIEKAssistantMessage(): boolean {
    return StringUtils.parseBoolean(this.read('userConfirmedIEKAssistantMessage'));
  }

  public set userConfirmedIEKAssistantMessage(value: boolean) {
    this.write('userConfirmedIEKAssistantMessage', value.toString(), 1);
  }


  public getLastSystemNotificationConfirmationTimestampForLocation(location: string): number {
    return this.readNumber('lastSystemNotificationConfirmationTimestamp_' + location);
  }

  public setLastSystemNotificationConfirmationTimestampForLocation(location: string, confirmationTimestamp: number, cookieExpireDate: Date) {
    this.writeNumberAndExpireDate('lastSystemNotificationConfirmationTimestamp_' + location, confirmationTimestamp, cookieExpireDate);
  }

  private read(name: string): string {
    const result: RegExpExecArray = new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)').exec(document.cookie);
    return result ? result[1] : null;
  }

  private readNumber(name: string): number {
    try {
      const value: string = this.read(name);
      return StringUtils.isEmpty(value) ? NaN : Number(value);
    } catch (e) {
      return NaN;
    }
  }

  private write(name: string, value: string, days?: number): void {
    if (!days) {
      days = 365;
    }
    let expireDate: Date;
    if (days === -1) {
      expireDate = null;
    } else {
      expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + (days * 24 * 60 * 60 * 1000));
    }
    this.writeWithExpireDate(name, value, expireDate);
  }

  private writeWithExpireDate(name: string, value: string, expireDate: Date): void {
    const expires: string = expireDate ? '; expires=' + expireDate.toUTCString() : '';
    document.cookie = name + '=' + value + expires + '; path=/; secure=true; SameSite=lax';
  }

  private writeNumber(name: string, value: number, days?: number): void {
    if (NumberUtils.isNotNumber(value) || StringUtils.isEmpty(name)) {
      return;
    }
    this.write(name, value.toString(), days);
  }

  private writeNumberAndExpireDate(name: string, value: number, expireDate: Date): void {
    if (NumberUtils.isNotNumber(value) || StringUtils.isEmpty(name)) {
      return;
    }
    this.writeWithExpireDate(name, value.toString(), expireDate);
  }
}
